export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const SET_LOADER = 'SET_LOADER'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const SET_ACTION = 'SET_ACTION'
export const LOGOUT_ACTION = 'LOGOUT_ACTION'
export const SET_WHITE_LABLE = 'SET_WHITE_LABLE'